<template>
  <v-col cols="12" md="6">
    <v-list density="compact">
      <v-list-subheader>
        <span style="line-height: 36px">Электронные почты:</span>
        <v-btn icon flat size="x-small" v-show="edit" @click="$emit('add')">
          <v-icon color="primary">add</v-icon>
        </v-btn>
      </v-list-subheader>
      <v-list-item
        v-for="(item, i) in emails"
        :key="i"
        base-color="primary"
      >
        <template v-slot:prepend>
          <v-icon color="primary">email</v-icon>
        </template>
        <template v-slot:append>
          <v-btn icon flat size="x-small" v-show="edit && item.id" @click="$emit('edit', item)">
            <v-icon icon="edit" size="x-small" color="primary"></v-icon>
          </v-btn>
          <v-btn icon flat size="x-small" v-show="edit && item.id" @click="$emit('delete', item)">
            <v-icon color="primary">delete</v-icon>
          </v-btn>
        </template>
        <v-list-item-title class="text-wrap">{{ item.email }} ({{ item.kind }})</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="emails && emails.length === 0">
        <template v-slot:prepend>
          <v-icon color="primary">email</v-icon>
        </template>
        <v-list-item-title>
          <span>не указан</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-col>
</template>

<script>
export default {
  name: "EmailsSection",
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    emails: {
      type: Array,
      default: () => []
    },
  },
  emits: ['add', 'edit', 'delete']
}
</script>

<style lang="scss" scoped>

</style>
